import AutoComplete from './auto-complete';

const modules = [
  new AutoComplete(),
];

export default modules;
